import styled from 'styled-components';

export const Title = styled.div`
    font-weight: bold;
    font-size: 1.25rem;
`;
